import { STATUS_FAIL } from '@/mixins/onlineCheckMixin';

/**
 * @description Примесь смен.
 * @type {object}
 */
export default {
  computed: {
    isAwaitShiftRequest() {
      return this.isAwaitOpenedShift || this.isAwaitCommandExecuted;
    },
  },
  data() {
    return {
      /**
       * @description Ожидание завершения открытия смены.
       * @type {boolean}
       */
      isAwaitShiftOpened: false,
      /**
       * @description Ожидание завершения запроса на открытие смены.
       * @type {boolean}
       */
      isAwaitOpenedShift: false,
      /**
       * @description Смена открыта.
       * @type {boolean}
       */
      isShiftOpened: false,
      /**
       * @description Показывать диалог открытия смены.
       * @type {boolean}
       */
      isShowShiftOpenDialog: false,
      /**
       * @description Уведомляемые о состоянии смены.
       * @type {Function[]}
       */
      notifiedOfShiftState: [],
    };
  },
  methods: {
    /**
     * @description Уведомить о состоянии смены.
     * @param {boolean} isOpened
     * @returns {void}
     */
    notifyOfShiftState(isOpened) {
      this.notifiedOfShiftState.forEach((notify) => {
        notify(isOpened);
      });
      this.notifiedOfShiftState = [];
      this.isAwaitShiftOpened = false;
    },
    /**
     * @description Дождаться открытия смены.
     * @returns {Promise<boolean>}
     */
    awaitShiftOpened() {
      if (this.isShiftOpened) {
        return Promise.resolve(true);
      }
      return new Promise((resolve) => {
        this.notifiedOfShiftState.push(resolve);
        if (!this.isAwaitShiftOpened) {
          this.isAwaitShiftOpened = true;
          this.checkShiftIsOpened();
        }
      });
    },
    /**
     * @description Проверить наличие открытой смены.
     * @returns {Promise<boolean>}
     */
    checkShiftIsOpened() {
      if (this.isShiftOpened) {
        return Promise.resolve(true);
      }
      const onFailure = (error) => {
        if (error.has('shift')) {
          this.openShiftDialog();
        } else {
          this.notifyFail(error.getTitle());
          this.notifyOfShiftState(false);
        }
        return false;
      };
      const onSuccess = () => {
        this.isShiftOpened = true;
        this.notifyOfShiftState(true);
        return this.isShiftOpened;
      };
      return this
        .$cashboxGateway
        .viewShiftState()
        .then((result) => result.fold(onFailure, onSuccess));
    },
    /**
     * @description Закрыть диалог смены.
     * @returns {void}
     */
    closeShiftDialog() {
      this.isShowShiftOpenDialog = false;
    },
    /**
     * @description Открыть диалог смены.
     * @returns {void}
     */
    openShiftDialog() {
      this.isShowShiftOpenDialog = true;
    },
    /**
     * @description Обработать открытие смены.
     * @returns {void}
     */
    onOpenShift() {
      this.isAwaitOpenedShift = true;
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
        this.notifyOfShiftState(false);
        return false;
      };
      const onSuccess = (result) => this.waitShiftOpened(result.command_id);
      return this
        .$cashboxGateway
        .openShift()
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => { this.isAwaitOpenedShift = false; });
    },
    /**
     * @description Дождаться открытия смены.
     * @param {number} commandId Идентификатор команды.
     * @returns {void}
     */
    waitShiftOpened(commandId) {
      const onFail = (error) => {
        this.notifyOfShiftState(false);
        this.notifyFail(error.getTitle());
      };
      const onSuccess = (result) => {
        if (result.status === STATUS_FAIL) {
          this.notifyOfShiftState(false);
          this.notifyFail(result.message);
          return;
        }
        this.notifySuccess('Смена открыта');
        this.closeShiftDialog();
        this.isShiftOpened = true;
        this.notifyOfShiftState(true);
        this.continueOperation();
      };
      return this
        .waitExecuted(commandId)
        .then(onSuccess, onFail)
        .finally(() => { this.isAwaitCommandExecuted = false; });
    },
    onCloseShiftDialog() {
      this.notifyOfShiftState(false);
      this.closeShiftDialog();
    },
    /**
     * @description Продолжить операцию.
     * @returns {void}
     */
    continueOperation() {
    },
  },
};
